<app-backend-status-banner *ngIf="!isPrintRoute"></app-backend-status-banner>
<ng-container *ngIf="isLoaded || isPrintRoute">
  <app-header *ngIf="!isPrintRoute"></app-header>
  <app-page-name
    [service]="service"
    *ngIf="!isPartBDetailView && !isPrintRoute"
  ></app-page-name>
  <router-outlet></router-outlet>
  <app-configurator
    *ngIf="configuratorEnabled && !isPrintRoute"
    hidden
  ></app-configurator>
</ng-container>
